module.exports = __webpack_public_path__ + "static/media/9S.0aa5dd7b.svg";